import { render, staticRenderFns } from "./yulan.vue?vue&type=template&id=6335d76a&scoped=true&"
import script from "./yulan.vue?vue&type=script&lang=js&"
export * from "./yulan.vue?vue&type=script&lang=js&"
import style0 from "./yulan.vue?vue&type=style&index=0&id=6335d76a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335d76a",
  null
  
)

export default component.exports